$(function () {

    Date.prototype.addDays = function (days) {
        var dat = new Date(this.valueOf());
        dat.setDate(dat.getDate() + days);
        return dat;
    }

    $.widget("movimax.schedule", {
        options: {
            date: new Date()
        },
        _create: function () {
            var opt = this.options;
            var $elm = this.element;
            var date = opt.date;

            // GET DATA
            var requestSchedule = function (date, callback) {
                var params = {};
                params.date = moment(date).format("DD MMM YYYY")
                encRequest("/showtime/showschedule", params, callback);
            };

            // CREATE ELEMENTS
            var generateSchedule = function (date) {

                $elm.html(""); // clear element

                var $schedule = $("<div>").addClass('schedule').appendTo($elm);
                var $headerDate = $("<div>").addClass('header-date').appendTo($schedule);

                var $headerDateText = $("<div>").addClass('header-date-text').appendTo($headerDate);
                var dt = moment(date).format("ddd, DD/MM/YYYY").toUpperCase();
                $headerDateText.text(dt);


                var $buttonList = $("<div>").addClass('button-list').appendTo($headerDate);
                var $btnYesterday = $("<button>").addClass('btn-rounded tooltipster').attr('title', 'Hari Kemarin').appendTo($buttonList);
                var $btnToday = $("<button>").addClass('btn-rounded tooltipster').attr('title', 'Hari Ini').appendTo($buttonList);
                var $btnTommorow = $("<button>").addClass('btn-rounded tooltipster').attr('title', 'Hari Selanjutnya').appendTo($buttonList);
                $("<i>").addClass("fa fa-chevron-left").appendTo($btnYesterday);
                $("<span>").text("").appendTo($btnYesterday);
                $("<i>").addClass("fa fa-chevron-down").appendTo($btnToday);
                $("<i>").addClass("fa fa-chevron-right").appendTo($btnTommorow);
                $("<span>").text("").prependTo($btnTommorow);

                $btnToday.unbind('click').bind('click', function () {
                    generateSchedule(new Date());
                });
                $btnYesterday.unbind('click').bind('click', function () {
                    generateSchedule(date.addDays(-1));
                });
                $btnTommorow.unbind('click').bind('click', function () {
                    generateSchedule(date.addDays(1));
                });


                var $slide = $("<div>").addClass('slide').css("max-height", "600px").appendTo($schedule);
                var $slideCtrl = $("<div>").addClass('slider-controls button-list').appendTo($slide);
                $("<div>").addClass('left-control').attr("id", "slider-prev").appendTo($slideCtrl);
                $("<div>").addClass('right-control').attr("id", "slider-next").appendTo($slideCtrl);

                var $bxSlider = $("<ul>").addClass('bx-slider-schedule').appendTo($slide);

                requestSchedule(date, function (reply) {
                    for (var loc in reply) {
                        var location = "MOVIMAX " + loc;
                        var data = reply[loc];
                        var $li = $("<li>").appendTo($bxSlider);
                        $("<div>").html(location).addClass('header').appendTo($li);
                        var $content = $("<div>").addClass('content').appendTo($li);
                        var $contentSchedule = $("<ul>").addClass('content-schedule').appendTo($content);
                        for (var i = 0; i < data.length; i++) {
                            var studio = data[i].studio;
                            var title = data[i].title;
                            var showtimes = data[i].show_time;
                            var $liContent = $("<li>").appendTo($contentSchedule);
                            var $leftSide = $("<div>").text(studio).addClass("left-side").appendTo($liContent);
                            var $rightSide = $("<div>").addClass("right-side").appendTo($liContent);
                            var $titleRow = $("<div>").addClass("title-row").text(title).appendTo($rightSide);
                            var $timeRow = $("<div>").addClass("time-row").appendTo($rightSide);
                            for (var j = 0; j < showtimes.length; j++) {
                                var $time = $("<div>").addClass("time").text(showtimes[j].hours).appendTo($timeRow);
                            }
                        }
                    }

                    // run bx slider
                    setTimeout(function () {
                        $(".bx-slider-schedule").bxSlider({
                            pause: 10000,
                            auto: false,
                            tickerHover: true,
                            nextSelector: '#slider-next',
                            prevSelector: '#slider-prev',
                            prevText: '<button class="btn-rounded"><i class="fa fa-chevron-left"></button>',
                            nextText: '<button class="btn-rounded"><i class="fa fa-chevron-right"></button>'
                        });
                    }, 300);


                });


                $schedule.mCustomScrollbar({
                    theme: 'minimal',
                    scrollInertia: 100
                });
            }

            generateSchedule(date);

        }
    });

});
